import { motion } from 'framer-motion';

const milestones = [
  {
    date: 'Sep 18, 2026',
    label: 'Early Bird Deadline',
    sub: '$15–25 entry fees',
    dotColor: 'border-teal',
  },
  {
    date: 'Oct 23, 2026',
    label: 'Regular Deadline',
    sub: '$20–30 entry fees',
    dotColor: 'border-teal',
  },
  {
    date: 'Nov 20, 2026',
    label: 'Late Deadline',
    sub: 'Last chance to submit',
    dotColor: 'border-gold',
  },
  {
    date: 'Jan 5, 2027',
    label: 'Notifications',
    sub: 'Selections announced',
    dotColor: 'border-teal',
  },
  {
    date: 'Jan 21–24, 2027',
    label: 'Festival',
    sub: 'Streaming worldwide',
    dotColor: 'border-orange',
  },
];

export default function Timeline() {
  return (
    <section className="max-w-[1200px] mx-auto px-6 py-24">
      {/* Eyebrow */}
      <motion.span
        className="font-mono text-teal uppercase block mb-4"
        style={{ fontSize: '0.7rem', letterSpacing: '0.25em' }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        Key Dates
      </motion.span>

      {/* Title */}
      <motion.h2
        className="font-display text-white leading-none mb-16"
        style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)' }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, delay: 0.1 }}
      >
        Mark your calendar.
      </motion.h2>

      {/* Timeline — Desktop: horizontal, Mobile: vertical */}
      <div className="relative">
        {/* Connecting gradient line — Desktop (horizontal) */}
        <div
          className="hidden md:block absolute top-[6px] left-0 right-0 h-[2px]"
          style={{
            background: 'linear-gradient(to right, #2ABFA3, #E8721C)',
          }}
        />

        {/* Connecting gradient line — Mobile (vertical) */}
        <div
          className="block md:hidden absolute top-0 bottom-0 left-[5px] w-[2px]"
          style={{
            background: 'linear-gradient(to bottom, #2ABFA3, #E8721C)',
          }}
        />

        {/* Milestones Grid */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-4">
          {milestones.map((m, i) => (
            <motion.div
              key={m.label}
              className="relative pl-8 md:pl-0"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.1 * i }}
            >
              {/* Dot */}
              <div
                className={`
                  w-3 h-3 rounded-full bg-dark border-2 ${m.dotColor}
                  absolute md:relative
                  left-0 top-0.5 md:left-auto md:top-auto
                  mb-4
                `}
              />

              {/* Date */}
              <span
                className="font-mono text-teal block mt-0 md:mt-3"
                style={{ fontSize: '0.65rem' }}
              >
                {m.date}
              </span>

              {/* Label */}
              <span
                className="font-medium text-white block mt-1"
                style={{ fontSize: '0.82rem' }}
              >
                {m.label}
              </span>

              {/* Sub */}
              <span
                className="text-muted block mt-0.5"
                style={{ fontSize: '0.72rem' }}
              >
                {m.sub}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
